import { jsx as _, jsxs as w } from "react/jsx-runtime";
import { Children as G, isValidElement as tr, forwardRef as ir } from "react";
function ar(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var V = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var L;
function _r() {
  return L || (L = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a.call(this, p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, this && this[p] || p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(V)), V.exports;
}
var or = _r();
const rr = /* @__PURE__ */ ar(or), lr = {
  "purpur-grid-item": "_purpur-grid-item_zx9tz_1",
  "purpur-grid-item--no-col-gap": "_purpur-grid-item--no-col-gap_zx9tz_6",
  "purpur-grid-item-colspan-sm-4": "_purpur-grid-item-colspan-sm-4_zx9tz_24",
  "purpur-grid-item-colspan-sm-3": "_purpur-grid-item-colspan-sm-3_zx9tz_27",
  "purpur-grid-item-colspan-sm-2": "_purpur-grid-item-colspan-sm-2_zx9tz_30",
  "purpur-grid-item-colspan-sm-1": "_purpur-grid-item-colspan-sm-1_zx9tz_33",
  "purpur-grid-item-colspan-md-8": "_purpur-grid-item-colspan-md-8_zx9tz_37",
  "purpur-grid-item-colspan-md-7": "_purpur-grid-item-colspan-md-7_zx9tz_42",
  "purpur-grid-item-colspan-md-6": "_purpur-grid-item-colspan-md-6_zx9tz_47",
  "purpur-grid-item-colspan-md-5": "_purpur-grid-item-colspan-md-5_zx9tz_52",
  "purpur-grid-item-colspan-md-4": "_purpur-grid-item-colspan-md-4_zx9tz_57",
  "purpur-grid-item-colspan-md-3": "_purpur-grid-item-colspan-md-3_zx9tz_62",
  "purpur-grid-item-colspan-md-2": "_purpur-grid-item-colspan-md-2_zx9tz_67",
  "purpur-grid-item-colspan-md-1": "_purpur-grid-item-colspan-md-1_zx9tz_72",
  "purpur-grid-item-colspan-lg-12": "_purpur-grid-item-colspan-lg-12_zx9tz_77",
  "purpur-grid-item-colspan-lg-11": "_purpur-grid-item-colspan-lg-11_zx9tz_82",
  "purpur-grid-item-colspan-lg-10": "_purpur-grid-item-colspan-lg-10_zx9tz_87",
  "purpur-grid-item-colspan-lg-9": "_purpur-grid-item-colspan-lg-9_zx9tz_92",
  "purpur-grid-item-colspan-lg-8": "_purpur-grid-item-colspan-lg-8_zx9tz_97",
  "purpur-grid-item-colspan-lg-7": "_purpur-grid-item-colspan-lg-7_zx9tz_102",
  "purpur-grid-item-colspan-lg-6": "_purpur-grid-item-colspan-lg-6_zx9tz_107",
  "purpur-grid-item-colspan-lg-5": "_purpur-grid-item-colspan-lg-5_zx9tz_112",
  "purpur-grid-item-colspan-lg-4": "_purpur-grid-item-colspan-lg-4_zx9tz_117",
  "purpur-grid-item-colspan-lg-3": "_purpur-grid-item-colspan-lg-3_zx9tz_122",
  "purpur-grid-item-colspan-lg-2": "_purpur-grid-item-colspan-lg-2_zx9tz_127",
  "purpur-grid-item-colspan-lg-1": "_purpur-grid-item-colspan-lg-1_zx9tz_77"
}, sr = rr.bind(lr), f = "purpur-grid-item", M = ({
  children: e,
  className: t,
  colSpanSm: u = 4,
  colSpanMd: a = 8,
  colSpanLg: i = 12,
  noColGap: r = !1,
  ...n
}) => {
  const p = sr([
    t,
    f,
    {
      [`${f}--no-col-gap`]: r,
      [`${f}-colspan-sm-${u}`]: u,
      [`${f}-colspan-md-${a}`]: a,
      [`${f}-colspan-lg-${i}`]: i
    }
  ]);
  return /* @__PURE__ */ _("div", { className: p, ...n, children: e });
}, dr = (e) => !!e && tr(e) && (!!e.props.colSpanSm || !!e.props.colSpanMd || !!e.props.colSpanLg);
M.displayName = "Grid.Item";
const cr = {
  "purpur-grid": "_purpur-grid_8kjv6_1",
  "purpur-grid__inner": "_purpur-grid__inner_8kjv6_27",
  "purpur-grid__inner--no-gap": "_purpur-grid__inner--no-gap_8kjv6_32",
  "purpur-grid__inner--no-row-gap": "_purpur-grid__inner--no-row-gap_8kjv6_32",
  "purpur-grid__inner--grid": "_purpur-grid__inner--grid_8kjv6_50",
  "purpur-grid__inner--no-col-gap": "_purpur-grid__inner--no-col-gap_8kjv6_54",
  "purpur-grid__inner-col-sm-4": "_purpur-grid__inner-col-sm-4_8kjv6_57",
  "purpur-grid__inner-col-sm-3": "_purpur-grid__inner-col-sm-3_8kjv6_60",
  "purpur-grid__inner-col-sm-2": "_purpur-grid__inner-col-sm-2_8kjv6_63",
  "purpur-grid__inner-col-md-8": "_purpur-grid__inner-col-md-8_8kjv6_67",
  "purpur-grid__inner-col-md-7": "_purpur-grid__inner-col-md-7_8kjv6_72",
  "purpur-grid__inner-col-md-6": "_purpur-grid__inner-col-md-6_8kjv6_77",
  "purpur-grid__inner-col-md-5": "_purpur-grid__inner-col-md-5_8kjv6_82",
  "purpur-grid__inner-col-md-4": "_purpur-grid__inner-col-md-4_8kjv6_87",
  "purpur-grid__inner-col-md-3": "_purpur-grid__inner-col-md-3_8kjv6_92",
  "purpur-grid__inner-col-md-2": "_purpur-grid__inner-col-md-2_8kjv6_97",
  "purpur-grid__inner-col-lg-12": "_purpur-grid__inner-col-lg-12_8kjv6_102",
  "purpur-grid__inner-col-lg-11": "_purpur-grid__inner-col-lg-11_8kjv6_107",
  "purpur-grid__inner-col-lg-10": "_purpur-grid__inner-col-lg-10_8kjv6_112",
  "purpur-grid__inner-col-lg-9": "_purpur-grid__inner-col-lg-9_8kjv6_117",
  "purpur-grid__inner-col-lg-8": "_purpur-grid__inner-col-lg-8_8kjv6_122",
  "purpur-grid__inner-col-lg-7": "_purpur-grid__inner-col-lg-7_8kjv6_127",
  "purpur-grid__inner-col-lg-6": "_purpur-grid__inner-col-lg-6_8kjv6_132",
  "purpur-grid__inner-col-lg-5": "_purpur-grid__inner-col-lg-5_8kjv6_137",
  "purpur-grid__inner-col-lg-4": "_purpur-grid__inner-col-lg-4_8kjv6_142",
  "purpur-grid__inner-col-lg-3": "_purpur-grid__inner-col-lg-3_8kjv6_147",
  "purpur-grid__inner-col-lg-2": "_purpur-grid__inner-col-lg-2_8kjv6_152",
  "purpur-grid__inner--flex": "_purpur-grid__inner--flex_8kjv6_156"
}, Z = rr.bind(cr), gr = "purpur-grid", g = "purpur-grid__inner", P = ({
  children: e,
  className: t,
  containerClassName: u,
  colsSm: a = 1,
  colsMd: i = 1,
  colsLg: r = 1,
  noGap: n = !1,
  noColGap: p = !1,
  noRowGap: d = !1,
  ...h
}) => {
  const l = G.toArray(e).filter(dr), c = l.length, v = Z([u, gr]), N = Z([
    t,
    g,
    {
      [`${g}--grid`]: !c,
      [`${g}--flex`]: c,
      [`${g}--no-gap`]: n,
      [`${g}--no-col-gap`]: p,
      [`${g}--no-row-gap`]: d,
      [`${g}-col-sm-${a}`]: a > 1 && !c,
      [`${g}-col-md-${i}`]: i > 1 && !c,
      [`${g}-col-lg-${r}`]: r > 1 && !c
    }
  ]);
  return /* @__PURE__ */ _("div", { className: v, ...h, children: /* @__PURE__ */ _("div", { className: N, children: c ? G.map(l, ({ props: { children: q, ...k } }) => /* @__PURE__ */ _(M, { ...k, noColGap: n || p, children: q })) : e }) });
};
P.displayName = "Grid";
P.Item = M;
function mr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var I = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var R;
function hr() {
  return R || (R = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a(p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(I)), I.exports;
}
var vr = hr();
const fr = /* @__PURE__ */ mr(vr), z = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, br = {
  TITLE100: "title-100"
}, j = "purpur-heading", nr = ({
  children: e,
  className: t = "",
  enableHyphenation: u = !1,
  negative: a = !1,
  tag: i,
  variant: r = br.TITLE100,
  ...n
}) => {
  const p = i, d = fr([
    t,
    z[j],
    z[`${j}--${r}`],
    {
      [z[`${j}--hyphens`]]: u,
      [z[`${j}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ _(p, { className: d, ...n, children: e });
};
nr.displayName = "Heading";
function yr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var T = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var E;
function xr() {
  return E || (E = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a(p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(T)), T.exports;
}
var $r = xr();
const wr = /* @__PURE__ */ yr($r), b = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, zr = {
  PARAGRAPH100: "paragraph-100"
}, y = "purpur-paragraph", A = ({
  ["data-testid"]: e,
  children: t,
  className: u,
  disabled: a,
  enableHyphenation: i = !1,
  negative: r = !1,
  variant: n = zr.PARAGRAPH100,
  ...p
}) => {
  const d = wr([
    u,
    b[y],
    b[`${y}--${n}`],
    {
      [b[`${y}--hyphens`]]: i,
      [b[`${y}--disabled`]]: a,
      [b[`${y}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ _("p", { ...p, className: d, "data-testid": e, children: t });
};
A.displayName = "Paragraph";
function jr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var O = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var D;
function Sr() {
  return D || (D = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a.call(this, p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, this && this[p] || p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(O)), O.exports;
}
var Nr = Sr();
const er = /* @__PURE__ */ jr(Nr), S = {
  "purpur-hero-banner": "_purpur-hero-banner_12i43_1",
  "purpur-hero-banner__grid-container": "_purpur-hero-banner__grid-container_12i43_4",
  "purpur-hero-banner__container": "_purpur-hero-banner__container_12i43_7",
  "purpur-hero-banner__container--with-media": "_purpur-hero-banner__container--with-media_12i43_16",
  "purpur-hero-banner__container--no-media": "_purpur-hero-banner__container--no-media_12i43_27",
  "purpur-hero-banner__breadcrumbs": "_purpur-hero-banner__breadcrumbs_12i43_38",
  "purpur-hero-banner__content": "_purpur-hero-banner__content_12i43_55",
  "purpur-hero-banner__content--no-media": "_purpur-hero-banner__content--no-media_12i43_73",
  "purpur-hero-banner__content--no-breadcrumbs": "_purpur-hero-banner__content--no-breadcrumbs_12i43_77",
  "purpur-hero-banner__content--no-additional-text": "_purpur-hero-banner__content--no-additional-text_12i43_81",
  "purpur-hero-banner__main-content": "_purpur-hero-banner__main-content_12i43_89",
  "purpur-hero-banner__main-content--no-media": "_purpur-hero-banner__main-content--no-media_12i43_97",
  "purpur-hero-banner__title": "_purpur-hero-banner__title_12i43_100",
  "purpur-hero-banner__preamble": "_purpur-hero-banner__preamble_12i43_107",
  "purpur-hero-banner__custom-content": "_purpur-hero-banner__custom-content_12i43_112",
  "purpur-hero-banner__actions": "_purpur-hero-banner__actions_12i43_116",
  "purpur-hero-banner__additional-text": "_purpur-hero-banner__additional-text_12i43_132",
  "purpur-hero-banner__media": "_purpur-hero-banner__media_12i43_136",
  "purpur-hero-banner__media--sm": "_purpur-hero-banner__media--sm_12i43_140",
  "purpur-hero-banner__media--lg": "_purpur-hero-banner__media--lg_12i43_148",
  "purpur-hero-banner__video-button": "_purpur-hero-banner__video-button_12i43_187"
}, qr = "purpur-hero-banner", kr = er.bind(S), Or = ({ children: e, className: t, ...u }) => /* @__PURE__ */ _("div", { ...u, className: kr([`${qr}__actions`, t]), children: e }), Ar = {
  LG: "lg"
};
function Mr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var F = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var U;
function Pr() {
  return U || (U = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a(p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(F)), F.exports;
}
var Cr = Pr();
const W = /* @__PURE__ */ Mr(Cr), Br = "_rotate_1xozj_1", Hr = "_dash_1xozj_1", x = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Br,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Hr,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, $ = "purpur-spinner", Gr = {
  SM: "sm"
}, Vr = ({
  ["data-testid"]: e,
  disabled: t = !1,
  negative: u = !1,
  size: a = Gr.SM,
  ...i
}) => /* @__PURE__ */ _(
  "div",
  {
    className: W([x[$], x[`${$}--${a}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ _("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ _(
      "circle",
      {
        className: W(x[`${$}__circle`], {
          [x[`${$}__circle--disabled`]]: t,
          [x[`${$}__circle--negative`]]: u
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Lr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var X = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Y;
function Zr() {
  return Y || (Y = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a.call(this, p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, this && this[p] || p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(X)), X.exports;
}
var Ir = Zr();
const Rr = /* @__PURE__ */ Lr(Ir), Tr = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Er = Rr.bind(Tr), m = "purpur-button", Dr = ({
  children: e,
  className: t,
  ["data-testid"]: u,
  disabled: a = !1,
  fullWidth: i = !1,
  iconOnly: r,
  loading: n = !1,
  negative: p = !1,
  onClick: d,
  size: h = "md",
  variant: l,
  type: c = "button",
  ...v
}, N) => {
  if (r && l === "destructive")
    return null;
  const q = Er(
    [
      m,
      `${m}--${p ? `${l}-negative` : l}`,
      `${m}--${h}`
    ],
    {
      [`${m}--icon-only`]: r,
      [`${m}--negative`]: p,
      [`${m}--full-width`]: i,
      [`${m}--disabled`]: a || n
    },
    t
  ), k = (H) => {
    a || n ? H.preventDefault() : d && d(H);
  }, B = !!v["aria-disabled"] || a || n;
  return /* @__PURE__ */ w(
    "button",
    {
      className: q,
      "data-testid": u,
      type: c,
      ref: N,
      "aria-disabled": B,
      onClick: k,
      ...v,
      children: [
        n && /* @__PURE__ */ _(Vr, { size: h === Ar.LG ? "xs" : "xxs", negative: p, disabled: B }),
        " ",
        e
      ]
    }
  );
}, pr = ir(Dr);
pr.displayName = "Button";
function Fr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var J = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var K;
function Ur() {
  return K || (K = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function u() {
        for (var r = "", n = 0; n < arguments.length; n++) {
          var p = arguments[n];
          p && (r = i(r, a.call(this, p)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return u.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var n = "";
        for (var p in r)
          t.call(r, p) && r[p] && (n = i(n, this && this[p] || p));
        return n;
      }
      function i(r, n) {
        return n ? r ? r + " " + n : r + n : r;
      }
      e.exports ? (u.default = u, e.exports = u) : window.classNames = u;
    })();
  }(J)), J.exports;
}
var Wr = Ur();
const Xr = /* @__PURE__ */ Fr(Wr), Yr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Jr = Xr.bind(Yr), Q = "purpur-icon", Kr = "md", Qr = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), rn = ({ content: e = "", title: t } = {}) => {
  const u = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = t ? `<title>${t}</title>` : "";
  return `<svg ${Qr(u)}>${a}${e}</svg>`;
}, nn = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), ur = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: u,
  className: a,
  size: i = Kr,
  ...r
}) => {
  const n = rn({
    content: nn(t.svg),
    title: u
  }), p = Jr(a, Q, `${Q}--${i}`);
  return /* @__PURE__ */ _(
    "span",
    {
      className: p,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: n },
      ...r
    }
  );
};
ur.displayName = "Icon";
const en = {
  name: "play-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 12 5.5 19.794V4.206L19 12Z"/><path fill-rule="evenodd" d="M19.875 12a.875.875 0 0 1-.438.758l-13.5 7.794a.875.875 0 0 1-1.312-.758V4.206a.875.875 0 0 1 1.313-.758l13.5 7.794c.27.156.437.445.437.758Zm-13.5-6.279V18.28L17.25 12 6.375 5.721Z" clip-rule="evenodd"/></svg>',
  keywords: ["play-filled"],
  category: "action"
}, pn = {
  name: "tv-pause",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 20h-3V4h3v16ZM8 20H5V4h3v16Z"/><path fill-rule="evenodd" d="M4.1 4a.9.9 0 0 1 .9-.9h3a.9.9 0 0 1 .9.9v16a.9.9 0 0 1-.9.9H5a.9.9 0 0 1-.9-.9V4Zm1.8.9v14.2h1.2V4.9H5.9Zm9.2-.9a.9.9 0 0 1 .9-.9h3a.9.9 0 0 1 .9.9v16a.9.9 0 0 1-.9.9h-3a.9.9 0 0 1-.9-.9V4Zm1.8.9v14.2h1.2V4.9h-1.2Z" clip-rule="evenodd"/></svg>',
  keywords: ["tv-pause"],
  category: "action"
}, un = "purpur-hero-banner", tn = ({
  children: e,
  isPlaying: t,
  togglePausePlay: u,
  videoPauseAriaLabel: a,
  videoPlayAriaLabel: i,
  className: r,
  ...n
}) => e && /* @__PURE__ */ w("div", { className: r, ...n, children: [
  e && e,
  !!u && /* @__PURE__ */ _(
    pr,
    {
      variant: "primary",
      negative: !0,
      iconOnly: !0,
      onClick: () => {
        u();
      },
      className: S[`${un}__video-button`],
      "aria-label": t ? a : i,
      children: /* @__PURE__ */ _(ur, { size: "xs", svg: t ? pn : en })
    }
  )
] }), s = er.bind(S), o = "purpur-hero-banner", C = ({
  children: e,
  className: t,
  breadcrumbs: u,
  title: a,
  titleTag: i = "h1",
  preamble: r,
  additionalText: n,
  media: p,
  ...d
}) => {
  const h = s([t, o]), l = !!p, c = !!u, v = !!n;
  return /* @__PURE__ */ _("section", { className: h, ...d, children: /* @__PURE__ */ w(
    P,
    {
      noGap: !0,
      className: s([
        `${o}__container`,
        {
          [`${o}__container--with-media`]: l,
          [`${o}__container--no-media`]: !l
        }
      ]),
      containerClassName: s(`${o}__grid-container`),
      children: [
        u && /* @__PURE__ */ _("div", { className: s(`${o}__breadcrumbs`), children: u }),
        /* @__PURE__ */ _("div", { className: s([`${o}__media`, `${o}__media--sm`]), children: p }),
        /* @__PURE__ */ w(
          "div",
          {
            className: s([
              `${o}__content`,
              {
                [`${o}__content--no-media`]: !l,
                [`${o}__content--no-breadcrumbs`]: !c,
                [`${o}__content--no-additional-text`]: !v
              }
            ]),
            children: [
              /* @__PURE__ */ w(
                "div",
                {
                  className: s([
                    `${o}__main-content`,
                    {
                      [`${o}__main-content--no-media`]: !l
                    }
                  ]),
                  children: [
                    a && /* @__PURE__ */ _(
                      nr,
                      {
                        enableHyphenation: !0,
                        negative: !0,
                        tag: i,
                        variant: "display-50",
                        className: s(`${o}__title`),
                        children: a
                      }
                    ),
                    r && /* @__PURE__ */ _(
                      A,
                      {
                        negative: !0,
                        variant: "preamble-100",
                        className: s(`${o}__preamble`),
                        children: r
                      }
                    ),
                    e && /* @__PURE__ */ _("div", { className: s(`${o}__custom-content`), children: e })
                  ]
                }
              ),
              n && /* @__PURE__ */ _(
                A,
                {
                  negative: !0,
                  variant: "additional-100",
                  className: S[`${o}__additional-text`],
                  children: n
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _("div", { className: s([`${o}__media`, `${o}__media--lg`]), children: p })
      ]
    }
  ) });
};
C.displayName = "HeroBanner";
C.Media = tn;
C.Actions = Or;
export {
  C as HeroBanner
};
//# sourceMappingURL=hero-banner.es.js.map
